import React from 'react'
import { AssociadoProvider } from '../../contexts/AssociadoContext'
import LazyComponent from '../../components/LazyComponent/LazyComponent'
import { ROUTE } from '../../constants'

import Perfil from './Perfil'

const Rotas = () => {
  return (
    <LazyComponent
      Component={ Perfil }
      Context={ AssociadoProvider }
      currentRoute={ ROUTE.PERFIL }
    />
  )
}

export default Rotas
